
import { useState, useRef, useEffect, Fragment } from "react";
import AWS from "aws-sdk";
import uuid from 'react-uuid';
import emailjs from '@emailjs/browser';
import Modal from '../utils/Modal';
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import { ArrowPathIcon } from '@heroicons/react/24/outline';
import { XCircleIcon } from '@heroicons/react/24/solid';
import { Spinner } from '../utils/Spinner';



function ContactForm() {

    const NO_ATTACHED_FILE = 'No Attached File'
    const RESIDENTIAL = 'Residential'
    const COMMERCIAL = 'Commercial'
    const GENERAL_INQUIRY = 'General Inquiry'
    const QUOTATION_INQUIRY = 'Request for Quotation'
    const formRef = useRef();
    const [inquiryType, setInquiryType] = useState(QUOTATION_INQUIRY);
    const [name, setName] = useState(null);
    const [file, setFile] = useState(null); // electric bill files (can be multiple)
    const [roofPlanFile, setRoofPlanFile] = useState(null); // roof plan files (can be multiple)
    const [electricalPlanFile, setElectricalPlanFile] = useState(null); // electrical plan (can be multiple)
    const [fileLink, setFileLink] = useState(null);
    const [roofPlanFileLink, setRoofPlanFileLink] = useState(null);
    const [electricalPlanFileLink, setElectricalPlanFileLink] = useState(null);

    const [roofDimension, setRoofDimension] = useState(null);

    const [email, setEmail] = useState(null);
    const [emailError, setEmailError] = useState(null);

    const [phone, setPhone] = useState(null);
    const [showSpinner, setShowSpinner] = useState(false)
    const [showEmailSent, setShowEmailSent] = useState(false);

    const [address, setAddress] = useState(null);
    const [mapPinLink, setMapPinLink] = useState(null);

    const [propertyType, setPropertyType] = useState(null);
    const [operatingHours, setOperatingHours] = useState(null);
    const [message, setMessage] = useState(null);
    const [captcha, setCaptcha] = useState(null);
    const [captchaError, setCaptchaError] = useState(null);

    const [requiredError, setRequiredError] = useState(null);

    const electricBillRef = useRef(null);
    const roofPlanRef = useRef(null);
    const electricalPlanRef = useRef (null);

    const converFilesObjToArray = (files) => {
        const fileCount = files.length;
        const file = [];
        for(let i=0; i<fileCount; ++i) {
            file.push(files[i])
        }
        return file;
    }

    // const handleFileChange = (e) => {
    //     const file = [...converFilesObjToArray(e.target.files)]
    //     console.log('File: ',file)
    //     setFile(file);
    //   };

    
    const handleSubmit = (e) => {
        if(validateCaptcha(captcha)) {
            setCaptchaError(null);
            const validateElectricBill = (inquiryType === QUOTATION_INQUIRY && file && propertyType) || (inquiryType !== QUOTATION_INQUIRY)
            if(name && phone && email && address && message && !emailError && validateElectricBill) {
                setRequiredError(null);
                setShowSpinner(true);
                if(file) {
                    //uploadFile()
                    uploadFiles()
                } else {
                    setShowSpinner(true)
                    setFileLink(NO_ATTACHED_FILE)
                }
            }
            else {
                setRequiredError(true);
            }
        } else {
            setCaptcha(null);
            setCaptchaError(true);
        }
        
    }

    const uploadFiles = async () => {
        // S3 Bucket Name
        const S3_BUCKET = "totalsolar-inquiry-upload";
        const s3Url = 'https://totalsolar-inquiry-upload.s3.us-east-2.amazonaws.com/';
        // S3 Region
        const REGION = "us-east-2";
        // S3 Credentials
        AWS.config.update({
            accessKeyId: process.env.REACT_APP_AWS_KEY,
            secretAccessKey: process.env.REACT_APP_AWS_SECRET,
        });
        const s3 = new AWS.S3({
            params: { Bucket: S3_BUCKET },
            region: REGION,
        });

        const uploads = [];
        const fileUploadNames = [];
        const roofPlanFileUploadNames = [];
        const electricalPlanFileUploadNames = [];

        const upload = (fileList, suffix, uploadNameList) => {
            if(Array.isArray(fileList)) {
                fileList.forEach((element, index) => {
                    const fileName = element.name.split('.')
                    const fileExt = fileName[fileName.length - 1]
    
                    const fileUploadName = referenceNumber+`_${suffix}`+index+'.'+fileExt
                    uploadNameList.push(s3Url + fileUploadName);
    
                    console.log('uploadName: ', fileUploadName)
                
                    // Files Parameters
                
                    const params = {
                        Bucket: S3_BUCKET,
                        Key: fileUploadName,
                        Body: element,
                    };
                
                    // Uploading file to s3
                
                    uploads.push(s3.putObject(params).on("httpUploadProgress", (evt) => {
                            // File uploading progress
                            console.log(fileUploadName,
                            "Uploading " + parseInt((evt.loaded * 100) / evt.total) + "%"
                            );
                        }).promise()
                    );
                });
            }
        }

        upload(file, 'bill', fileUploadNames);
        upload(roofPlanFile, 'roof', roofPlanFileUploadNames);
        upload(electricalPlanFile, 'electrical', electricalPlanFileUploadNames);

    
        Promise.all(uploads).then((err, data) => {
          console.log(err);
          setRoofPlanFileLink(roofPlanFileUploadNames.join(', '));
          setElectricalPlanFileLink(electricalPlanFileUploadNames.join(', '));
          setFileLink(fileUploadNames.join(', '));
         
          
        }).catch(() => {
            setShowSpinner(false)
        });
      };

    useEffect(() => {
        if(fileLink!==null) {
            setShowSpinner(false)
            const template = `${fileLink===NO_ATTACHED_FILE ? 'totalSolar_noFile' : 'totalSolar1'}`
            emailjs.sendForm('service_jrdev', template, formRef.current, 'MWxDlOJLGlGug3_41')
            .then((result) => {
                setShowEmailSent(true)
            }, (error) => {
                // show the user an error
            }).finally(()=>{
                setFileLink(null)
            });
        }
    }, [fileLink])

    const [referenceNumber, setReferenceNumber] = useState(null);

    const generateNewReferenceNumber = () => {
        const uniqueId = uuid().substring(0,6);
        const dateNow = new Date()
        const refNum = 'TS'+dateNow.getFullYear()+(dateNow.getMonth()+1).toString().padStart(2,'0')+dateNow.getDate().toString().padStart(2,'0')+'_'+uniqueId
        return refNum
    }
    useEffect(() => {
        loadCaptchaEnginge(6); 
        setReferenceNumber(generateNewReferenceNumber())
    }, [])
    
    const resetForm = () => {
        console.log('reset')
        formRef.current.reset();
        setName(null);
        setPhone(null);
        setEmail(null);
        setAddress(null);
        setFile(null);
        setFileLink(null);
        setMessage(null);
        setShowEmailSent(false);
        setCaptcha(null);
        setReferenceNumber(generateNewReferenceNumber())
        setPropertyType(null);
    }


    const AsteriskRequired = () => <>
        <span className='text-red-500'>*</span>
    </>
    return <>
    <Spinner show={showSpinner} onClose={()=>{}}/>
    <Modal show={showEmailSent} onClose={()=>resetForm()}>
        <p className='text-center my-2'>You Reference Number is {referenceNumber}</p>
        <p>Our team will contact you asap.</p>
    </Modal>
    <form id='contact-form' className='w-full' ref={formRef}>
        <input type='hidden' name='referenceNumber' value={referenceNumber || ''} />

        <div className="relative text-black py-1">
            <div className="text-xs text-left font-semibold py-1">Type of Inquiry</div>
            <div className="flex flex-col items-start my-1 mx-2">
                <div className="flex items-center" onClick={()=>setInquiryType(QUOTATION_INQUIRY)} >
                    <input className="text-black px-3 pt-[0.8rem] cursor-pointer" 
                        type="radio"
                        name='inquiryType' 
                        readOnly
                        checked={inquiryType===QUOTATION_INQUIRY} />
                    <label className="pl-1 cursor-pointer">Request for Quotation</label>
                </div>
                
                <div className="flex items-center" 
                     onClick={()=>{
                        setInquiryType(GENERAL_INQUIRY)
                        setPropertyType(null)
                        setOperatingHours(null)
                        setFile(null)
                        setRoofPlanFile(null)
                        setRoofDimension(null)
                        setElectricalPlanFile(null)
                     }} >
                <input className="text-black px-3 pt-[0.8rem] cursor-pointer" 
                    type="radio"
                    name='propertyType'
                    readOnly
                    checked={inquiryType===GENERAL_INQUIRY} />
                <label className="pl-1 cursor-pointer">General Inquiry</label>
                </div>
                
            </div>
            
        </div>

        <div className="relative text-black py-3">
            <label className="text-xs font-semibold absolute px-3 pt-1">Name <AsteriskRequired/></label>
            <input className="text-black rounded-xl w-full h-[50px] px-3 pt-[0.8rem]" 
                value={name || ''}
                onChange={(e) => setName(e.target.value)}
                name='name' placeholder="Juan dela Cruz" required/>
        </div>

        <div className="flex flex-col sm:flex-row justify-between">
            <div className="relative text-black py-3 w-full sm:w-[49%]">
                <label className="text-xs font-semibold absolute px-3 pt-1">Phone <AsteriskRequired/></label>
                <input className="text-black rounded-xl w-full h-[50px] px-3 pt-[0.8rem]" name='phone' 
                    onChange={(e) => {
                        if(!isNaN(e.target.value)) {
                            setPhone(e.target.value)
                        }
                    }}
                    value={phone || ''}
                    placeholder="09171234567" required/>
            </div>

            <div className="relative text-black py-3 w-full sm:w-[49%]">
                <label className="text-xs font-semibold absolute px-3 pt-1" id="emial-label">Email <AsteriskRequired/></label>
                <input className={`text-black rounded-xl w-full h-[50px] px-3 pt-[0.8rem] ${emailError && 'border-2 border-red-500'}`}
                        name='email' value={email || ''} 
                        id='email-field' spellCheck="false" 
                        onChange={(e) => setEmail(e.target.value)}
                        onInput={(e) => {
                        if(!/^[A-Za-z\._\-0-9]*[@][A-Za-z]*[\.][a-z]{2,4}$/.test(e.target.value)) {
                            setEmailError("Please enter a valid email")
                        } else {
                            setEmailError(null)
                        }
                        }}
                        placeholder="juandelacruz@gmail.com" required/>
                {
                    emailError &&
                    <span className="text-red-500 italic text-xs" id="email-error">{emailError}</span>
                }
            </div>
        </div>

        <div className="relative text-black py-3">
            <label className="text-xs font-semibold absolute px-3 pt-1">Address <AsteriskRequired/></label>
            <input className="text-black rounded-xl w-full h-[50px] px-3 pt-[0.8rem]" 
                value={address || ''}
                onChange={(e) => setAddress(e.target.value)}
                name='address' placeholder="Complete Address" required/>
        </div>

        {
            inquiryType === QUOTATION_INQUIRY && <>
                <div className="relative text-black py-3">
                    <label className="text-xs font-semibold absolute px-3 pt-1">Google Map Pin Link (Optional)</label>
                    <input className="text-black rounded-xl w-full h-[50px] px-3 pt-[0.8rem]" 
                        value={mapPinLink || ''}
                        onChange={(e) => setMapPinLink(e.target.value)}
                        name='mapPinLink' placeholder="https://maps.app.goo.gl/jEhX2bgjr2jmqj1i8" />
                </div>
                <div className="relative text-black py-1">
                    <div className="text-xs text-left font-semibold py-1">Property Type <AsteriskRequired/></div>
                    <div className="flex flex-col items-start my-1 mx-2">
                        <div className="flex items-center" onClick={()=>setPropertyType(RESIDENTIAL)} >
                            <input className="text-black px-3 pt-[0.8rem] cursor-pointer" 
                                type="radio"
                                name='propertyType' 
                                readOnly
                                checked={propertyType===RESIDENTIAL} />
                            <label className="pl-1 cursor-pointer">Residential</label>
                        </div>
                        
                        <div className="flex items-center" onClick={()=>setPropertyType(COMMERCIAL)} >
                        <input className="text-black px-3 pt-[0.8rem] cursor-pointer" 
                            type="radio"
                            name='propertyType'
                            readOnly
                            checked={propertyType===COMMERCIAL} />
                        <label className="pl-1 cursor-pointer">Commercial</label>
                        </div>
                        
                    </div>
                    
                </div>

                {
                    propertyType === COMMERCIAL && <>
                    
                    <div className="relative text-black py-3">
                        <label className="text-xs font-semibold absolute px-3 pt-1">Operating Hours<AsteriskRequired/></label>
                        <input className="text-black rounded-xl w-full h-[50px] px-3 pt-[0.8rem]" 
                            value={operatingHours || ''}
                            onChange={(e) => setOperatingHours(e.target.value)}
                            name='operatingHours' placeholder="Hours of Operation" required/>
                    </div>
                    </>
                }
                

                <div className="relative py-3 text-left">
                    <label className="text-xs font-semibold pt-1">Latest Electric Bill <AsteriskRequired/></label>
                    <div className="italic text-[0.65rem]">Upload at least 3 to 6 consecutive months of electric bill</div>
                    <button type='button' className="text-[#f7f7f7] px-3 py-1 mt-2 mb-3 rounded-full text-xs font-bold w-fit bg-gray-500 hover:bg-[#4CB117] hover:text-[#212121]"
                            onClick={()=>electricBillRef.current.click()}>
                        Upload
                    </button>
                    <ul>
                        {
                            file?.map(((uploadedFile, index) => <Fragment key={'electricBillFile'+index}>
                                <li className="flex items-center">
                                    <div className="truncate text-xs">{uploadedFile.name}</div> 
                                    <XCircleIcon className="w-[10%] h-4 w-4 text-red-500 cursor-pointer" 
                                            onClick={()=>{
                                                file.splice(index,1)
                                                setFile([...file])
                                            }}/>
                                </li>
                            </Fragment>))
                        }
                    </ul>
                    <input type="file" ref={electricBillRef} id="electricBillFileId" className="hidden"
                        accept="image/*,.pdf"
                        multiple
                        onChange={(e) => {
                            const selectedFiles = [...converFilesObjToArray(e.target.files)]
                            console.log('File: ',selectedFiles)
                            setFile([...(file || []), ...selectedFiles]);
                        }} />
                    <input type='hidden' name='electricBillLink' value={fileLink  || ''} />
                </div>

                <div className="relative py-3 text-left">
                    <label className="text-xs font-semibold pt-1">Roof Plan (Optional)</label>
                    <div className="italic text-[0.65rem]">Upload a roof plan</div>
                    <button type='button' className="text-[#f7f7f7] px-3 py-1 mt-2 mb-3 rounded-full text-xs font-bold w-fit bg-gray-500 hover:bg-[#4CB117] hover:text-[#212121]"
                            onClick={()=>roofPlanRef.current.click()}>
                        Upload
                    </button>
                    <ul>
                        {
                            roofPlanFile?.map(((uploadedFile, index) => <Fragment key={'roofPlanFile'+index}>
                                <li className="flex items-center">
                                    <div className="truncate text-xs">{uploadedFile.name}</div> 
                                    <XCircleIcon className="w-[10%] h-4 w-4 text-red-500 cursor-pointer" 
                                            onClick={()=>{
                                                roofPlanFile.splice(index,1)
                                                setRoofPlanFile([...roofPlanFile])
                                            }}/>
                                </li>
                            </Fragment>))
                        }
                    </ul>
                    <input type="file" ref={roofPlanRef} id="roofPlanFileId" className="hidden"
                        accept="image/*,.pdf"
                        multiple
                        onChange={(e) => {
                            const selectedFiles = [...converFilesObjToArray(e.target.files)]
                            console.log('File: ',selectedFiles)
                            setRoofPlanFile([...(roofPlanFile || []), ...selectedFiles]);
                        }} />
                    <input type='hidden' name='roofPlanFileLink' value={roofPlanFileLink  || ''} />
                </div>


                <div className="italic text-[0.65rem] text-left">If no roof plan, roof dimension or area in square meters will do</div>
                <div className="relative text-black pb-3">
                    <label className="text-xs font-semibold absolute px-3 pt-1">Roof Dimension (Optional)</label>
                    <input className="text-black rounded-xl w-full h-[50px] px-3 pt-[0.8rem]" 
                        value={roofDimension || ''}
                        onChange={(e) => setRoofDimension(e.target.value)}
                        name='roofDimension' placeholder="Roof Dimension"/>
                </div>

                <div className="relative py-3 text-left">
                    <label className="text-xs font-semibold pt-1">Electrical Plan (Optional)</label>
                    <div className="italic text-[0.65rem]">Upload an electrical plan</div>
                    <button type='button' className="text-[#f7f7f7] px-3 py-1 mt-2 mb-3 rounded-full text-xs font-bold w-fit bg-gray-500 hover:bg-[#4CB117] hover:text-[#212121]"
                            onClick={()=>electricalPlanRef.current.click()}>
                        Upload
                    </button>
                    <ul>
                        {
                            electricalPlanFile?.map(((uploadedFile, index) => <Fragment key={'electricalPlanFile'+index}>
                                <li className="flex items-center">
                                    <div className="truncate text-xs">{uploadedFile.name}</div> 
                                    <XCircleIcon className="w-[10%] h-4 w-4 text-red-500 cursor-pointer" 
                                            onClick={()=>{
                                                electricalPlanFile.splice(index,1)
                                                setElectricalPlanFile([...electricalPlanFile])
                                            }}/>
                                </li>
                            </Fragment>))
                        }
                    </ul>
                    <input type="file" ref={electricalPlanRef} id="electricalPlanFileId" className="hidden"
                        accept="image/*,.pdf"
                        multiple
                        onChange={(e) => {
                            const selectedFiles = [...converFilesObjToArray(e.target.files)]
                            console.log('File: ',selectedFiles)
                            setElectricalPlanFile([...(electricalPlanFile || []), ...selectedFiles]);
                        }} />
                    <input type='hidden' name='electricalPlanFileLink' value={electricalPlanFileLink  || ''} />
                </div>
            </>
        }
        

        <div className="relative text-black py-3">
            <label className="text-xs font-semibold absolute px-3 pt-1">Message</label>
            <textarea className="text-black rounded-xl w-full h-[50px] px-3 pt-[1.5rem] min-h-[150px]" name='message' placeholder="Additional information or questions"
                value={message || ''}
                onChange={(e) => setMessage(e.target.value)}/>
        </div>

        <div className='my-1 flex flex-col lg:flex-row items-start'>
            
            <div className="relative text-black mb-2 lg:mr-3">
                <input className="text-black rounded-xl w-full h-[30px] px-3 text-xs" 
                    value={captcha || ''}
                    onChange={(e) => setCaptcha(e.target.value)}
                    placeholder="Type captcha"/>
            </div>
            <LoadCanvasTemplateNoReload />
            <button type='button' className='text-xs mt-2 lg:mt-0 ml-0 sm:ml-2 flex hover:bg-green-600 bg-green-700 text-white p-2 rounded-xl whitespace-nowrap' 
                onClick={()=>{
                    loadCaptchaEnginge(6)
                    setCaptcha(null);
                    setCaptchaError(null);
                }}><ArrowPathIcon className='h-4 w-4' /></button>
            
        </div>
        
        
        <div className='flex flex-wrap justify-start mt-5'>
            {
                captchaError && <p className='w-full italic text-left text-red-500 text-sm'>*Please match the captcha.
                </p>
            }
            {
                requiredError && <p className='w-full italic text-left text-red-500 text-sm'>*Please fill in all fields.
                </p>
            }
            <button type='button' className="text-[#f7f7f7] px-6 py-3 mt-2 mb-3 rounded-full text-sm font-bold w-fit bg-[#212121] hover:bg-[#4CB117] hover:text-[#212121]"
                    onClick={handleSubmit}>
                Send Email
            </button>
        </div>
        
    </form>
    </>;
  }


  
  export default ContactForm;